import { MutationKeys } from '@/enums/mutation-keys'
import { QueryKeys } from '@/enums/query-keys'
import { useResidentService } from '@/services/resident'
import { AcceptTermsAndConditionsResponse } from '@/types/resident'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export function useAcceptTermsAndConditions(
  options?: Omit<
    UseMutationOptions<
      AcceptTermsAndConditionsResponse | null,
      Error,
      { termsOfServiceVersionId: string; privacyPolicyVersionId: string }
    >,
    'mutationKey' | 'mutationFn'
  >,
) {
  const queryClient = useQueryClient()
  const residentService = useResidentService()

  return useMutation<
    AcceptTermsAndConditionsResponse | null,
    Error,
    { termsOfServiceVersionId: string; privacyPolicyVersionId: string }
  >({
    mutationKey: [MutationKeys.acceptTermsAndConditions],
    mutationFn: ({ termsOfServiceVersionId, privacyPolicyVersionId }) =>
      residentService.acceptTermsAndConditions(
        termsOfServiceVersionId,
        privacyPolicyVersionId,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          QueryKeys.getTermsAndConditionsAcceptance,
          QueryKeys.getActiveTermsOfServiceVersion,
          QueryKeys.getActivePrivacyPolicyVersion,
        ],
      })
      queryClient.refetchQueries({
        queryKey: [
          QueryKeys.getTermsAndConditionsAcceptance,
          QueryKeys.getActiveTermsOfServiceVersion,
          QueryKeys.getActivePrivacyPolicyVersion,
        ],
      })
    },
    ...options,
  })
}
